import { EnvironmentType } from "src/app/enums/enums";

export const environment = {
  production: false,
  apiUrl: 'https://emasuperltapitest.clavisco.com/',
  name: `Super LT`,
  type: EnvironmentType.Testing,
  env: 'Testing',
};
